export const StockPage = () => {
  return (
    <div className="stock-page">
      Stock page not unlocked yet.
    </div>
  )
};